// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__DeDvE","link__underline":"link_link__underline__INJ4l"};